import { __spreadArrays } from "tslib";
import { noop } from '@wix/answers-lib';
import * as React from 'react';
import { Column, Row, Icon } from '..';
import { iconsMap } from '../../icons/processed';
import { Button, Text } from '../../new-libby';
var drillAndSelectDisabled = "You can\u2019t place a category within itself, or\nwithin one of its subcategories. To move this\ncategory, select another destination.";
var selectDisabled = "You can place articles only in categories\nthat don\u2019t contain subcategories.";
export var searchDebounceTime = 250;
export var noOptions = function (noOptionsTexts) {
    var title = noOptionsTexts.title, desc = noOptionsTexts.desc;
    return (React.createElement(Column, { className: 'no-options-message', verticalAlignment: 'center', horizontalAlignment: 'center' },
        React.createElement(Row, { className: 'title', horizontalAlignment: 'center' },
            React.createElement(Text, { color: 't20', type: 'hxsm' }, title)),
        React.createElement(Row, null,
            React.createElement(Text, { color: 't40', type: 'ts' }, desc))));
};
export var noResults = function (noResultsText, query) {
    var title = noResultsText.title, desc = noResultsText.desc;
    return (React.createElement(Column, { className: 'no-search-results-message', verticalAlignment: 'center', horizontalAlignment: 'center' },
        React.createElement(Row, { className: 'title', horizontalAlignment: 'center' },
            React.createElement(Text, { color: 't20', type: 'ts' }, title),
            React.createElement(Text, { className: 'no-search-results-query', color: 't20', type: 'tsm' },
                " \u2019",
                query,
                "\u2019")),
        React.createElement(Row, null,
            React.createElement(Text, { color: 't40', type: 'ts' }, desc))));
};
export var chevronIcon = function (onMouseDownCapture, iconColor, disabled) {
    return (React.createElement("span", { onMouseDownCapture: onMouseDownCapture },
        React.createElement(Row, { verticalAlignment: 'center', className: 'chevron-wrapper', horizontalAlignment: 'center' },
            React.createElement(Button, { disabled: disabled, className: 'menu-drill-button', onClick: noop, type: 'tertiary' },
                React.createElement(Icon, { color: iconColor, icon: iconsMap.arrowNext })))));
};
export var getDeepPath = function (find, options) {
    var path = [];
    var getDeepPathInner = function (items) {
        var _a;
        var _loop_1 = function (item) {
            var itemChildrenValues = (_a = item.children) === null || _a === void 0 ? void 0 : _a.map(function (v) { return v.value; });
            if (find && find.every(function (val) { return itemChildrenValues === null || itemChildrenValues === void 0 ? void 0 : itemChildrenValues.includes(val.value); })) {
                path = __spreadArrays([item], path);
                return { value: path };
            }
            else if (item.children) {
                getDeepPathInner(item.children);
                if (path.length > 0) {
                    path = __spreadArrays([item], path);
                    return { value: path };
                }
            }
        };
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var state_1 = _loop_1(item);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return [];
    };
    getDeepPathInner(options);
    return path;
};
export var filterResults = function (label, allOptions) {
    var relevantOptions = [];
    var filterOptionsInner = function (items) {
        var matchingOptions = items.filter(function (item) { return item.label.toString().toLowerCase().includes(label.toLowerCase()); });
        if (!!matchingOptions.length) {
            relevantOptions = __spreadArrays(matchingOptions, relevantOptions);
        }
        items.forEach(function (item) {
            if (item.children) {
                filterOptionsInner(item.children);
            }
        });
        return matchingOptions;
    };
    filterOptionsInner(allOptions);
    return relevantOptions;
};
//dummy data for drill select
export var dummyDrillOptions = [
    {
        value: '1', label: 'Option 1', children: [
            { value: '1-1', label: 'Option 1-1' },
            { value: '1-2', label: 'Option 1-2' },
        ]
    },
    {
        value: '2', label: 'Option 2', children: [
            { value: '2-1', label: 'Option 2-1' },
            {
                value: '2-2', label: 'Option 2-2', children: [
                    { value: '2-2-1', label: 'Option 2-2-1' },
                    {
                        value: '2-2-2', label: 'Option 2-2-2', children: [
                            { value: '2-2-2-1', label: 'Option 2-2-2-1' },
                            {
                                value: '2-2-2-2', label: 'Option 2-2-2-2', children: [
                                    { value: '2-2-2-2-1', label: 'Option 2-2-2-2-1' },
                                    {
                                        value: '2-2-2-2-2', label: 'Option 2-2-2-2-2', children: [
                                            { value: '2-2-2-2-2-1', label: 'Option 2-2-2-2-2-1' },
                                            { value: '2-2-2-2-2-2', label: 'Option 2-2-2-2-2-2' },
                                            {
                                                value: '2-2-2-2-2-3', label: 'Option 2-2-2-2-2-3', children: [
                                                    { value: '2-2-2-2-2-3-1', label: 'Option 2-2-2-2-2-3-1' },
                                                    {
                                                        value: '2-2-2-2-2-3-2', label: 'Option 2-2-2-2-2-3-2', drillDisabled: 'Cannot be drilled, can be selected', children: [
                                                            { value: '2-2-2-2-2-3-2-1', label: 'Option 2-2-2-2-2-3-2-1' },
                                                        ]
                                                    },
                                                    {
                                                        value: '2-2-2-2-2-3-3', label: 'Option 2-2-2-2-2-3-3', children: [
                                                            { value: '2-2-2-2-2-3-3-1', label: 'Option 2-2-2-2-2-3-3-1' },
                                                            {
                                                                value: '2-2-2-2-2-3-3-2', label: 'Option 2-2-2-2-2-3-3-2', children: [
                                                                    { value: '2-2-2-2-2-3-3-2-1', label: 'Option 2-2-2-2-2-3-3-2-1' },
                                                                    {
                                                                        value: '2-2-2-2-2-3-3-2-2', label: 'Option 2-2-2-2-2-3-3-2-2', children: [
                                                                            { value: '2-2-2-2-2-3-3-2-2-1', label: 'Option 2-2-2-2-2-3-3-2-2-1' },
                                                                            { value: '2-2-2-2-2-3-3-2-2-2', label: 'Option 2-2-2-2-2-3-3-2-2-2' },
                                                                        ]
                                                                    },
                                                                ]
                                                            },
                                                        ]
                                                    },
                                                ]
                                            },
                                        ]
                                    },
                                ]
                            },
                            { value: '2-2-2-3', label: 'Option 2-2-2-3' }
                        ]
                    }
                ]
            },
            {
                value: '2-3', label: 'Option 2-3', children: [
                    { value: '2-3-1', label: 'Option 2-3-1' },
                    { value: '2-3-2', label: 'Option 2-3-2' },
                    { value: '2-3-3', label: 'Option 2-3-3 long long long long ' },
                ]
            }
        ]
    },
    {
        value: '3',
        drillAndSelectDisabled: drillAndSelectDisabled,
        label: 'Option 3', children: [
            { value: '3-1', label: 'Option 3-1' },
        ]
    },
    {
        value: '4', label: 'Option 4', children: [
            { value: '4-1', label: 'Option 4-1' },
            { value: '4-2', label: 'Option 4-2' },
            { value: '4-3', label: 'Option 4-3' }
        ]
    },
    { value: '5', label: 'Option 5' },
    {
        value: '6',
        selectDisabled: selectDisabled,
        label: 'Option 6', children: [
            { value: '6-1', label: 'Option 6-1' },
            { value: '6-2', label: 'Option 6-2' }
        ]
    },
    { value: '7', label: 'Option 7' }
];
export var drillSelectorsTexts = {
    select: 'Select',
    results: 'results',
    resultsLimit: function (filteredOut) { return "This search has " + filteredOut + " more results that are not displayed. Try searching for a more specific term to narrow down the results."; },
    noResults: {
        title: 'No search results',
        desc: 'Try a different search',
    },
    noOptions: {
        title: 'No options',
        desc: 'No items to select'
    }
};
//# sourceMappingURL=drill-selectors-common.js.map